// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#aw--c #aw-sl .player-adon[data-v-7c628192]{padding:5px!important;background:rgba(0,0,0,.5)!important}", ""]);
// Exports
module.exports = exports;
